import React, { useState } from 'react';
import { ChevronDown, Menu, RotateCcw } from 'lucide-react';
const FILTERS = ['Develop A Skill', 'Maps To Subject', 'Concept', 'Teaching Method'];
export function SearchScreen() {
  const [tab, setTab] = useState<'standard' | 'textbook'>('standard');
  const [keyword, setKeyword] = useState('');
  return <section className="h-full overflow-y-auto px-4 pb-3 pt-2 text-white" data-id="element-106" data-mp="88375qlddvsr">
      <div className="flex items-center justify-between" data-id="element-107" data-mp="m844wx6c8n40"><button aria-label="Open menu" className="grid h-7 w-7 place-items-center rounded-full bg-[#5b5268]/85" data-id="element-108" data-mp="m6t14xcw7fcw"><Menu className="h-4 w-4" data-id="element-109" data-mp="h7gjcr0voyh6" /></button><button aria-label="Reset search" onClick={() => setKeyword('')} className="grid h-7 w-7 place-items-center rounded-full bg-[#5b5268]/85" data-id="element-110" data-mp="vy77np39hffj"><RotateCcw className="h-3.5 w-3.5" data-id="element-111" data-mp="r0oxjvdicu5y" /></button></div>
      <h1 className="mt-2 text-base font-bold" data-id="element-112" data-mp="14yvmun4e5lu0">Search</h1>
      <div className="mt-2 grid grid-cols-2 gap-1 rounded-md bg-[#5b5268]/80 p-1" data-id="element-113" data-mp="14zeunb0butub">
        <Tab active={tab === 'standard'} onClick={() => setTab('standard')} data-id="element-114" data-mp="101n52nn5njta">Standard Search</Tab>
        <Tab active={tab === 'textbook'} onClick={() => setTab('textbook')} data-id="element-115" data-mp="2nq2a9smdm9yd">Textbook Search</Tab>
      </div>
      <FormSelect label="Explore Rangeet" value="Index" data-id="element-116" data-mp="2sodki4gl2mh4" />
      <Field label="Keyword" value={keyword} onChange={setKeyword} placeholder="Keyword" data-id="element-117" data-mp="2xmf4qspqwru6" />
      {FILTERS.map(label => <FormSelect key={label} label={label} value="Select" data-id="element-118" data-mp="32n2tt8ueyylr" />)}
      <button className="mt-3 w-full rounded-md bg-white py-2 text-xs font-extrabold tracking-wide text-[#3b3544]" data-id="element-119" data-mp="36nmq6a75xy6u">SEARCH</button>
    </section>;
}
function Tab({
  active,
  onClick,
  children
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return <button onClick={onClick} className={`rounded px-1 py-1.5 text-[9px] font-bold ${active ? 'bg-[#f2a2b2] text-[#443847]' : 'text-white'}`} data-id="element-120" data-mp="3ge7wykwzq90u">{children}</button>;
}
function Field({
  label,
  value,
  onChange,
  placeholder
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) {
  return <label className="mt-2 block text-[9px] font-medium" data-id="element-121" data-mp="3uauvut8i799e"><span data-id="element-122" data-mp="1v9iotvbnnlju">{label}</span><input value={value} onChange={event => onChange(event.target.value)} placeholder={placeholder} className="mt-1 h-7 w-full rounded bg-[#5b5268]/80 px-2 text-[9px] text-white placeholder:text-white/55 outline-none focus:ring-1 focus:ring-white" data-id="element-123" data-mp="1v8z466umej24" /></label>;
}
function FormSelect({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <label className="mt-2 block text-[9px] font-medium" data-id="element-124" data-mp="2dyyqilz2tk1u"><span data-id="element-125" data-mp="2dxnkefi5s07k">{label}</span><button className="mt-1 flex h-7 w-full items-center justify-between rounded bg-[#5b5268]/80 px-2 text-left text-[9px] text-white" data-id="element-126" data-mp="2dx45z8rpvtya"><span data-id="element-127" data-mp="2mzn27a0zz8bk">{value}</span><ChevronDown className="h-3 w-3" data-id="element-128" data-mp="2n058z0lad4xq" /></button></label>;
}